import { stoked } from "./stoked_values"

const isNotProduction = stoked.getValue("rails-env") !== "production"
const isDebug = stoked.getValue("debug") || window.debug === true

const log = (message) => {
  if (isNotProduction || isDebug) {
    console.log(message)
  }
}

const logError = (message) => {
  if (isNotProduction || isDebug) {
    console.error(message)
  }
}

export { log, logError }
